import { ReactComponent as AddIcon } from "assets/images/icons/btn_add.svg";
import { ReactComponent as UploadIcon } from "assets/images/icons/icn_btn_export_pressed.svg";
import { ReactComponent as BinIcon } from "assets/images/icons/icn_btn_bin.svg";
import { ReactComponent as CheckDefIcon } from "assets/images/icons/checkbox_default.svg";
import { ReactComponent as CheckClearIcon } from "assets/images/icons/checkbox_clear.svg";
import { ReactComponent as CheckFillIcon } from "assets/images/icons/checkbox_fiilled.svg";
import { ReactComponent as CloseIcon } from "assets/images/icons/icn_close.svg";

import React, { useRef } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import zIndex from '@mui/material/styles/zIndex';

// Component
import { OutlineRectangleButton } from "components/buttons/OutlineRectangleButton";
import { OutlineButton } from "components/buttons/OutlineButton";
import { SolidButton } from "components/buttons/SolidButton";
import MacAddressTableRow from "./TableRow";
import LoadingElement from "../loadingElement";
import AddView from "./AddView";
import UploadView from "./UploadView";
import FromClientView from "./FromClientView";

const MainView = ({
  auth,
  viewStateEnum,
  getViewTitle,
  viewState,
  changeViewState,
  form,
  formValue,
  readyToRenderTable,
  selectedIndexes,
  setSelectedIndexes,
  closeModal,
  handleMainView,
  showEditGeneral,
}) => {
  const theme = useTheme();
  const viewRef = useRef(null);

  // Status
  const [isDirtyName, setIsDirtyName] = React.useState(false);

  // Method
  const clickAddButton = () => {
    changeViewState(viewStateEnum.ADD);
  }

  const clickUploadButton = () => {
    changeViewState(viewStateEnum.UPLOAD);
  }

  const clickFromClientButton = () => {
    changeViewState(viewStateEnum.FROM_CLIENT);
  }

  function HandleAddView() {
    return {
      closeView: () => {
        changeViewState(viewStateEnum.MAIN);
      },
      addMacAddresses: (newMacAddresses) => {
        handleMainView.addMacAddresses(false, newMacAddresses);
      }
    }
  }

  function HandleUploadView() {
    return {
      closeView: () => {
        changeViewState(viewStateEnum.MAIN);
      },
      updateMacAddressItemsList: (replaceFlag, newMacAddressItems) => {
        handleMainView.addMacAddresses(replaceFlag, newMacAddressItems);
      }
    }
  }

  function HandleFromClientView() {
    return {
      closeView: () => {
        changeViewState(viewStateEnum.MAIN);
      },
      handleApply: (selectedMacAddressItems) => {
        handleMainView.addMacAddresses(false, selectedMacAddressItems);
      }
    }
  }

  // Side Effects

  if (!readyToRenderTable) {
    return <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.primary.main,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.customFontSize[5],
            fontWeight: theme.typography.customFontWeight[3],
            paddingLeft: "20px",
          }}
        >
          {getViewTitle(viewStateEnum.MAIN)}
        </Typography>
      </Box>
      <LoadingElement />
    </>
  }

  const viewWidth = viewRef && viewRef.current ? viewRef.current.offsetWidth : 0;
  let viewHeight = viewRef && viewRef.current ? viewRef.current.offsetHeight : 0;
  let marginTop = 0;
  if (viewRef && viewRef.current) {
    viewHeight = viewRef.current.offsetHeight;
    marginTop = viewHeight / 6;
  }

  const isNameValid = isDirtyName ? formValue.name.trim().length > 0 && formValue.name.trim().length <= 64 : true;

  return (
    <>
      <Box
        ref={viewRef}
        style={{
          position: "relative",
          padding: '0',
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: theme.palette.primary.main,
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.customFontSize[5],
              fontWeight: theme.typography.customFontWeight[3],
              paddingLeft: "20px",
            }}
          >
            {getViewTitle(viewStateEnum.MAIN)}
          </Typography>
          <Button
            onClick={closeModal}
            sx={{
              backgroundColor: theme.palette.primary.transparent,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: theme.palette.primary.transparent,
              },
            }}
          >
            <CloseIcon />
          </Button>
        </Box>

        <Box sx={{ paddingLeft: "26px", }}>
          {/* MAC Group Name */}
          <Box sx={form.getRowStyle()}>
            <Box sx={form.getLabelStyle()}>MAC Group Name</Box>
            <TextField
              placeholder=""
              inputProps={{
                minLength: 1,
                maxLength: 64,
              }}
              disabled={!showEditGeneral}
              sx={form.getTextfieldStyle(isNameValid)}
              value={formValue.name}
              onChange={(e) => {
                setIsDirtyName(true);
                handleMainView.changeFormValue("name", e.target.value)
              }}
            />
          </Box>

          <Box sx={form.getRowStyle()}>
            <Box sx={form.getLabelStyle()}>MAC Address List</Box>
            <Box display="flex" gap="10px" justifyContent={"flex-end"} sx={{ flexGrow: 1 }}>
              {
                showEditGeneral && (
                  <>
                    <OutlineRectangleButton
                      startIcon={<AddIcon />}
                      height="32px"
                      onClick={clickAddButton}
                    >
                      Add
                    </OutlineRectangleButton>
                    <OutlineRectangleButton
                      startIcon={<UploadIcon />}
                      height="32px"
                      onClick={clickUploadButton}
                    >
                      Upload
                    </OutlineRectangleButton>
                    <OutlineRectangleButton
                      startIcon={<AddIcon />}
                      height="32px"
                      onClick={clickFromClientButton}
                    >
                      Add from Client List
                    </OutlineRectangleButton>
                    {
                      selectedIndexes.length > 0 && (
                        <OutlineRectangleButton
                          startIcon={<BinIcon />}
                          disabled={!showEditGeneral}
                          height="32px"
                          onClick={handleMainView.deleteSelectedMacAddresses}
                        >
                          Delete<Box sx={form.getNumberStyle()}>{selectedIndexes.length}</Box>
                        </OutlineRectangleButton>
                      )
                    }
                  </>
                )
              }
            </Box>
          </Box>

          {/* Use table hook to render table too slow, so use MUI table directly */}
          <Box sx={{ ...form.getTableStyle() }}>
            <TableContainer
              component={Paper}
              sx={{
                "&.MuiPaper-root": {
                  boxShadow: "none",
                  border: 'none',
                },
              }}
              style={{ height: '300px', overflowY: 'auto' }}
            >
              <Table
                sx={{
                  borderCollapse: "collapse",
                  "& td, & th": {
                    border: "none",
                  },
                  "& tbody tr:nth-of-type(odd)": {
                    backgroundColor: 'rgb(246, 246, 246)',
                  },
                  "& tbody tr:nth-of-type(even)": {
                    backgroundColor: theme.palette.primary.white,
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    {
                      showEditGeneral && (
                        <>
                          <TableCell>
                            <Checkbox
                              icon={<CheckDefIcon style={{ width: "25px", height: "25px" }} />}
                              checkedIcon={<CheckFillIcon style={{ width: "25px", height: "25px" }} />}
                              indeterminateIcon={<CheckClearIcon style={{ width: "25px", height: "25px" }} />}
                              indeterminate={
                                selectedIndexes.length > 0 &&
                                selectedIndexes.length < formValue.macAddresses.length
                              }
                              checked={
                                formValue.macAddresses.length > 0 &&
                                selectedIndexes.length === formValue.macAddresses.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedIndexes(formValue.macAddresses.map((_, index) => index));
                                } else {
                                  setSelectedIndexes([]);
                                }
                              }}
                            />
                          </TableCell>
                        </>
                      )
                    }
                    <TableCell sx={{ fontWeight: 600 }}>MAC Address</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Description(Optional)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    formValue.macAddresses.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={3}
                          sx={{
                            textAlign: "center",
                            padding: "20px",
                          }}
                        >
                          No Entry in the table
                        </TableCell>
                      </TableRow>
                    ) : (
                      <>
                        {
                          formValue.macAddresses.map((mac, index) => (
                            <>
                              <MacAddressTableRow
                                key={index}
                                form={form}
                                originalMacAddresses={formValue.macAddresses}
                                mac={mac}
                                index={index}
                                disabled={!showEditGeneral}
                                onMacChange={handleMainView.changeMacAddressItemValue}
                                onDescChange={handleMainView.changeDescriptionItemValue}
                                isSelected={selectedIndexes.includes(index)}
                                onSelect={(i) =>
                                  setSelectedIndexes((prev) =>
                                    prev.includes(i)
                                      ? prev.filter((idx) => idx !== i)
                                      : [...prev, i]
                                  )
                                }
                              />
                            </>
                          ))
                        }
                      </>
                    )
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>

        <Box
          sx={{
            margin: "24px 0 16px auto",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OutlineButton
            onClick={closeModal}
            sx={{ marginRight: "20px" }}
            width="100px"
            height="32px"
          >
            Cancel
          </OutlineButton>
          <SolidButton
            onClick={handleMainView.handleSave}
            width="100px"
            height="32px"
            disabled={!showEditGeneral || !handleMainView.checkFormValid()}
          >
            Apply
          </SolidButton>
        </Box>

        {
          viewState !== viewStateEnum.MAIN && (
            <Box
              style={{
                ...form.getMaskStyle(),
                width: viewWidth + 40 + 'px',
                height: viewHeight + 60 + 'px',
                transform: `translateY(-20px) translateX(-20px)`,
              }}
            />
          )
        }
      </Box >

      {
        viewState === viewStateEnum.ADD && (
          <>
            <Box style={{
              ...form.getInnerViewStyle(zIndex),
              marginTop: marginTop,
            }} >
              <Box style={form.getInnerContainerStyle()}>
                <AddView
                  viewStateEnum={viewStateEnum}
                  getViewTitle={getViewTitle}
                  changeViewState={changeViewState}
                  closeModal={closeModal}
                  form={form}
                  handleAddView={HandleAddView()}
                />
              </Box>
            </Box>
          </>
        )
      }

      {
        viewState === viewStateEnum.UPLOAD && (
          <>
            <Box style={{
              ...form.getInnerViewStyle(zIndex),
              width: viewWidth + 40 + 'px',
              transform: `translateY(${marginTop}px)`,
            }} >
              <Box style={form.getInnerContainerStyle()}>
                <UploadView
                  viewStateEnum={viewStateEnum}
                  getViewTitle={getViewTitle}
                  form={form}
                  handleUploadView={HandleUploadView()}
                />
              </Box>
            </Box>
          </>
        )
      }

      {
        viewState === viewStateEnum.FROM_CLIENT && (
          <>
            <Box style={{
              ...form.getInnerViewStyle(zIndex),
              width: viewWidth + 40 + 'px',
              transform: `translateY(${marginTop}px)`,
            }} >
              <Box style={form.getInnerContainerStyle()}>
                <FromClientView
                  auth={auth}
                  viewStateEnum={viewStateEnum}
                  getViewTitle={getViewTitle}
                  form={form}
                  handleFromClientView={HandleFromClientView()}
                  showEditGeneral={showEditGeneral}
                />
              </Box>
            </Box>
          </>
        )
      }
    </>
  )
}

export default React.memo(MainView);